import { render } from "./LinkButtonNodeView.vue?vue&type=template&id=71182373&scoped=true"
import script from "./LinkButtonNodeView.vue?vue&type=script&lang=js"
export * from "./LinkButtonNodeView.vue?vue&type=script&lang=js"

import "./LinkButtonNodeView.vue?vue&type=style&index=0&id=71182373&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71182373"]])

export default __exports__